const apiUrl = process.env.REACT_APP_API_URL;
export const PostLlistatAlumneCasalPdf = async (llistat : any, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/inscripcions/alumnecasal/llistats`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(llistat)
        });
        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
